import {Component, OnInit} from '@angular/core';
import {AsyncPipe, CommonModule, NgForOf, NgIf} from "@angular/common";
import {BaseSectionComponent} from "../base-section/base-section.component";
import {SynapiListItemsComponent} from "../../elements/synapi-list-items/synapi-list-items.component";
import {TinyPostComponent} from "../../elements/tiny-post/tiny-post.component";
import {TinyPostsFromIdsPipe} from "../../../pipes/tinyPostFromId/tiny-post-from-id.pipe";
import {ContextTriggers, PageContextSection} from "../../../models/Page/Sections/PageContextSection";
import {Meteo} from "../../../models/Misc/Meteo";
import {WordpressService} from "../../../services/wordpress.service";
import {FindPipe} from "../../../pipes/find.pipe";
import {toggleTrigger} from "../../../trigger/toggle.trigger";

@Component({
  selector: 'context-section',
  standalone: true,
  imports: [
    AsyncPipe,
    BaseSectionComponent,
    NgForOf,
    NgIf,
    SynapiListItemsComponent,
    TinyPostComponent,
    TinyPostsFromIdsPipe,
    CommonModule,
    FindPipe
  ],
  animations: [
    toggleTrigger
  ],
  templateUrl: './context-section.component.html',
  styleUrl: './context-section.component.scss'
})
export class ContextSectionComponent  extends BaseSectionComponent<PageContextSection> implements OnInit{
  public meteo : Meteo;

  constructor(public wp : WordpressService) {
    super();
  }

  override async ngOnInit() {
    super.ngOnInit();
    this.meteo = await this.wp.getMeteo();
    if (this.sectionRendered.list_contexts?.length > 0) {
      this.sectionRendered.list_contexts = this.sectionRendered.list_contexts.filter((c) => !c.is_disabled).map((c) => {
        c.tri = 0;
        if (c.trigger.find((t) => t === ContextTriggers.RAINY) && this.meteo.rainy) {
          c.tri += 10;
        }
        if (c.trigger.find((t) => t === ContextTriggers.SUNNY) && this.meteo.sunny) {
          c.tri += 5;
        }
        if (c.trigger.find((t) => t === ContextTriggers.WINDY) && this.meteo.windy) {
          c.tri += 5;
        }
        if (c.trigger.find((t) => t === ContextTriggers.WEEKEND)) {
          const day = new Date().getDay();
          if (day === 0 || day === 6) {
            c.tri += 5;
          }
          else {
            c.tri -= 5;
          }
        }
        if (c.trigger.find((t) => t === ContextTriggers.SUNDAY)) {
          const day = new Date().getDay();
          if (day === 0) {
            c.tri += 10;
          } else {
            c.tri -= 5;
          }
        }
        if (c.trigger.find((t) => t === ContextTriggers.EVENING)) {
          const hours = new Date().getHours();
          if ([18,19,20,21,22,23,0,1,2].find((i)=>i == hours)) {
            c.tri += 15;
          }
        }
        if (c.trigger.find((t) => t === ContextTriggers.IMPORTANT)) {
          c.tri += 20;
        }
        return c;
      }).sort((a, b) => b.tri - a.tri);
      if (this.sectionRendered.list_contexts?.length > 0) {
        this.onActiveClick(this.sectionRendered.list_contexts[0]);
      }
    }
  }

  onActiveClick(line:any){
    this.sectionRendered.list_contexts.map((l)=>{
      l.active = false;
    });
    line.active=true;
  }

  protected readonly ContextTriggers = ContextTriggers;
}
